export const FILMDETAIL_ITEM = {
  category: {
    title: {
      vi: 'Thể loại',
      en: 'Category',
    },
  },
  directors: {
    title: {
      vi: 'Đạo diễn',
      en: 'Directors',
    },
    error: '',
  },
  nation: {
    title: {
      vi: 'Quốc gia',
      en: 'Nation',
    },
    error: '',
  },
  time: {
    title: {
      vi: 'Thời lượng',
      en: 'Time',
    },
    error: '',
  },
  rating: {
    title: {
      vi: 'Đánh giá',
      en: 'Rating',
    },
  },
  year: {
    title: {
      vi: 'Năm phát hành',
      en: 'Release year',
    },
  },
};
